var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_31_1392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6164 3.86546H12.3836C8.6124 3.86546 6.72678 3.86546 5.55521 5.03704C4.38364 6.20861 4.38364 8.09423 4.38364 11.8655V13C4.38364 16.7712 4.38364 18.6569 5.55521 19.8284C6.72678 21 8.6124 21 12.3836 21H12.6164C16.3876 21 18.2732 21 19.4448 19.8284C20.6164 18.6569 20.6164 16.7712 20.6164 13V11.8655C20.6164 8.09423 20.6164 6.20861 19.4448 5.03704C18.2732 3.86546 16.3876 3.86546 12.6164 3.86546Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6164 3.86546H12.3836C8.6124 3.86546 6.72678 3.86546 5.55521 5.03704C4.38364 6.20861 4.38364 8.09423 4.38364 11.8655V13C4.38364 16.7712 4.38364 18.6569 5.55521 19.8284C6.72678 21 8.6124 21 12.3836 21H12.6164C16.3876 21 18.2732 21 19.4448 19.8284C20.6164 18.6569 20.6164 16.7712 20.6164 13V11.8655C20.6164 8.09423 20.6164 6.20861 19.4448 5.03704C18.2732 3.86546 16.3876 3.86546 12.6164 3.86546Z",
    stroke: "#3B1F8E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49985 12H10.9047",
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49985 16H12.9087",
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44182 2.62976V5.00777",
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.62976V5.00777",
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5582 2.62976V5.00777",
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_31_1392",
    x: 3.63364,
    y: 3.11546,
    width: 17.7327,
    height: 18.6345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.121569 0 0 0 0 0.556863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_31_1392"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.2393deb98706ed57f3f1a2a99b639907.svg";
export { ForwardRef as ReactComponent };